import { Typography } from '@branchjs/neo-components';
import React from 'react';
import { ImageService } from '../../../../main/services/ImageService/ImageService';
import { useStyles } from './SignupPanelSection.styles';
import type { SignupPanelSectionProps } from './SignupPanelSection.types';

export function SignupPanelSection(props: SignupPanelSectionProps) {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      {props.imageUrl && <img src={ImageService.getImageUrl(props.imageUrl)} alt={props.imageAlt} />}
      <div>
        {props.title && (
          <Typography className={classes.sectionTitle} variant={'h4'}>
            {props.title}
          </Typography>
        )}
        {props.children}
      </div>
    </div>
  );
}
